import AccessoriyList from "@/views/project/accessoriy/accessoriyList.vue";

export default {
  公司介绍: {
    公司介绍: "Company introduction",
    叉车租赁已达19年: "19 years of forklift leasing operation",
    我们提供: "We provide",
    多样化的租赁模式: "Diversified leasing modes",
    完善的售后回租业务: "Perfect leaseback business",
    一体化的服务网络: "Integrated service network",
    专业化的服务团队: "Professional service team",
    保障性的服务方案: "Guaranteed service proposal",
    叉车租赁: "Forklift leasing",
    租赁模式: "Leasing mode",
    不同规格: "Different specifications",
    不同品牌: "Different brands",
    多种类型: "Multiple types",
    多款车型: "Multiple models",
    "叉车载重从1吨-10吨不等,不同吨数可满足客户不同租赁要求":
      "Forklift loads range from 1 ton to 10 tons,  meeting different leasing requirements of customers",
    "TOTOTA、BT、JUNGHEINRICH、NICHIYU等为我公司的战略":
      "TOTOTA、BT、JUNGHEINRICH、NICHIYU are our company's strategic partners",
    电动叉车和柴油叉车为客户带来不同环境叉车租赁需求:
      "We provide electric and diesel forklifts to meet customers' forklift leasing needs under different environments",
    "仓储叉车，平衡重叉车，牵引车，前移式叉车，托盘车，拣选叉车等多种的叉车类型":
      "Storage forklift, counterbalance forklift, tractor, straddle reach trucks, pallet truck, picking forklift and many other forklift truck types",
    叉车租赁形式: "Forklift leasing mode",
    服务体系: "service system",
    快速可靠: "fast and reliable",
    专业化服务: "professional service",
    "4小时的及时响应": "4-hour prompt response",
    "48小时的换车服务": "48-hour replacement service",
    完善的服务网络: "Perfect service network",
    专业叉车服务团队: "Professional forklift service team",
    短期租赁服务: "Short-term leasing service",
    "短期租赁可以按天，周，月计算":
      "Short-term leasing can be calculated by day, week, and month",
    中长期租赁服务: "medium /long-term leasing service",
    提供中长期租赁和短期租赁相结合的灵活租赁模式:
      "We provide flexible leasing modes with a combination of medium /long-term leasing and short-term leasing",
    融资性租赁服务: "Financial leasing services",
    在租赁期满后设备产权自动转移给租赁客户:
      "The property rights of the equipment will be automatically transferred to the customer after the lease contract expires",
    大客户的灵活租赁: "Flexible leasing for fleet customers",
    "提供叉车选型，叉车数量，叉车调配等方面的灵活组合":
      "We provide flexible proposals with a combination of forklift models, quantities, and distributions, etc",
    传统服务方案: "Traditional service scheme",
    人工全责服务: "Full responsibility service",
    "特别推荐：全责服务": "Special recommendation: Full responsibility service",
  },
  联系我们: {
    销售团队: "Sales team",
    采购团队: "Service team",
    主要销售地点: "Main sales location",
    捷丰销售地点地址: "Jiefeng sales location address",
    在地图中显示: "Display on the map",
    仓库面积达40000平方米:
      "The warehouse covers an area of 40,000 square meters",
    核心仓库: "Core warehouse",
    捷丰核心仓库地址: "Jiefeng core warehouse address",
    "仓库距离货运公路2,000米":
      "The warehouse is 2,000 metres from the freight road",
    其他: "Others",
    "捷丰林合工业设备(上海)有限公司":
      "Jiefeng Linhe Industrial Equipment (Shanghai) Co., LTD",
    江苏省太仓市陆渡镇江南路81号丰田叉车:
      // "Toyota Forklift, No. 81 Jiangnan Road, Ludu Town, Taicang City, Jiangsu Province",
      "Jiefeng Used Forklift Center, Intersection of Guangzhou West Road and National Highway 204, Fuhao Economic Development Zone, Shuangfeng Town, Taicang City, Jiangsu Province",
    "统一社会信用代码：": "Unified social credit code ",
    "销售服务热线:": "Sales hotline:",
    "开户行：": "Bank of deposit:",
    中国银行上海市宁虹路支行: "Ninghong Road branch, Bank of China, Shanghai",
    "银行账号：": "Bank account:",
  },
  top: {
    库里的叉车: "Forklifts Available",
    在途的叉车: "Forklifts OnWay",
    叉车属具: "Attachments",
    新闻中心: "News Center",
    公司介绍: "Profile",
    联系我们: "Contact Us",
    电话: "Call",
    联系人姓名: "Contact person",
    收藏: "Add to favorite",
    比较: "Compare",
    登录: "Login",
    中文: "Chinese",
    英文: "English",
    语言: "Language",
  },
  bottom: {
    "捷丰林合工业设备(上海)有限公司":
      "Jiefeng Linhe Industrial Equipment (Shanghai) Co., LTD",
    江苏省太仓市陆渡镇江南路81号丰田叉车:
      // "Toyota Forklift, No. 81 Jiangnan Road, Ludu Town, Taicang City, Jiangsu Province",
      "Jiefeng Used Forklift Center, Intersection of Guangzhou West Road and National Highway 204, Fuhao Economic Development Zone, Shuangfeng Town, Taicang City, Jiangsu Province",
    "统一社会信用代码:91310120324706632P":
      "Unified social credit code:91310120324706632P",
    企业网站: "Company website: http://www.jfrental.com/",
    社交媒体: "Social media",
    相关社群: "Relevant community",
    "隐私政策|版权所有©捷丰林合工业设备(上海)有限公司":
      "Privacy Policy | Copyright © Jiefeng Linhe Industrial Equipment (Shanghai) Co., LTD.",
  },
  库里的叉车: {
    重置筛选条件: "Reset Filter",
    模糊查询: "Search Text",
    车辆品牌: "Brand",
    车辆类型: "Type of Forklift",
    属具类型: "Attachment type",
    动力方式: "Power Unit",
    门架类型: "Mast",
    载重能力: "Loading Capitity",
    提升高度: "Lifting Height",
    叉车回落高度: "Overall Height",
    生产年份: "Production Year",
    工作小时数: "Working Hours",
    阀路: "Valve",
    其他: "Others",
    "+ 展开": "+ Unfold",
    "- 收起": "- Fold",
  },
  车辆详情: {
    生产年份: "Year of production",
    动力方式: "Power unit",
    负载能力: "Load capacity",
    提升高度: "lifting height",
    升降: "Lift up and down",
    工作小时数: "Working hours",
    登录后查询价格: "Check the price after login",
    如需帮助请拨打: "If you need help, please call",
    查询: "Search",
    播放: "Play",
    分享: "Share",
    收藏: "Add to favorite",
    比较: "Compare",
    打印PDF: "Print PDF",
    下载图片: "Download picture",
    车辆参数: "Parameters",
    登记号: "Serial Number",
    "负载能力 公斤": "Loading Capacity",
    "提升高度 毫米": "lifting height",
    "叉车回落高度 毫米": "Overall height",
    阀路: "valve",
    动力方式: "Power unit",
    生产年份: "Year of production",
    叉车自重: "Weight",
    电池情况: "Battery",
    入库时间: "Arrived date",
    预计到货时间: "Expected delivery time",
    车辆属性: "Equipment",
    属具类型: "Attachment type",
    车辆类型: "Type of forklift",
    门架类型: "Mast",
    车架号: "Serial number",
    车辆牌照号: "Vehicle licence number",
    工作小时数: "Working hours",
    其他车辆: "Similar Trucks",
  },
  车辆详情页右侧: {
    登录后查询价格: "Check the price after login",
    不含增值税价格: "Price without VAT",
    查询: "Query",
    如需帮助请拨打: " If you need help, please call",
    "拨打电话 周一至周日": " Monday to Sunday, please call",
    人员姓名: "刘辉",
  },
  叉车属具详情: {
    品牌: "Brand",
    负载能力: "Load capacity",
    重量: "Weight",
    生产年份: "Year of production",
    在船上: "On board",
    登录后查询价格: "Check the price after login",
    查询: "Query",
    视频: "Video",
    需要帮助请联系: "If you need help, please contact",
    属具参数: "Attachment parameters",
    登记号: "Serial Number",
    规格型号: "Attachment parameters",
    属具类型: "About Type",
    "负载能力 公斤": "Loading Capacity",
    "提升高度 毫米": "Lifting height",
    "建筑高度 毫米": "Building height millimeter",
    起重设备: "Lifting equipment",
    驱动: "Drive",
    生产年份: "Year of production",
    "重量 公斤": "Weight  Kg",
    电池: "Battery",
    技术状态: "Technical condition",
    功能的: "Functional",
    前轮: "Front wheel",
    后轮: "Rear wheel",
    位置: "Location",
    属具属性: "Attachment attributes",
    其他属具: "Similar Attachments",
  },
  叉车属具: {
    设备类型: "Equipment type",
    负载能力: "Load capacity",
    从: "From",
    到: "To",
    品牌: "Brand",
    在船上: "On board",
    搜索: "Search",
    条件重置: "Condition reset",
  },
  新闻明细: {
    点赞: "Like",
    浏览: "View",
    本文标签: "Tag",
    浏览次数: "Number of views",
    次浏览: "View times",
    发布日期: "Publish date",
  },
  新闻中心: {
    新闻中心: "News Center",
    点赞: "Like",
    浏览: "View",
  },
  accessoriyDetail: {
    品牌: "Brand",
    重量: "Weight",
    生产年份: "Year of production",
    在船上: "On board",
    登录后查询价格: "Check the price after login",
    详情: "Details",
    询价: "Query ",
  },
  accessoriyList: {
    品牌: "Brand",
    请选择: "Please select",
    按照车架号和车辆型号模糊搜索:
      "Fuzzy search by serial number and forklift model",
  },
  quotation: {
    设备询价单: "Equipment inquiry sheet",
    现在询问底价: "Check the bottom price now",
    删除: "Delete",
    公司名称: "Company name",
    您的姓名: "Your name",
    电子邮箱: "Email",
    联系电话: "Cellphone",
    询问内容: "Inquiry content",
  },
  forkmodel: {
    新引进的: "Newly introduced",
    登录后查询价格: "Check the price after login",
    详情: "Details",
    询价: "Query",
  },
  compare: {
    对比装卸车: "compare loading trucks ",
    导出PDF: "Export PDF",
    全部删除: "Delete all",
    询价所有装卸车: "Inquiry for all loading trucks",
    删除: "Delete",
    "生产商 型号": "Manufacture  Model",
    价格: "Price",
    "负载能力 公斤": "Loading Capacity",
    "升降 毫米": "Lift up and down  millimeter",
    "叉车回落高度 毫米": "Forklift dropping height  millimeter",
    动力方式: "Power unit",
    阀路: "Valve",
    电池情况: "Battery",
    生产年份: "Year of production",
    工作小时数: "Working hours",
    叉车自重: "Weight",
    属具类型: "Attachment type",
    门架类型: "Mast",
    查询: "Query",
    询价: "Query",
    全部删除: "Delete all",
    询价所有装卸车: "Inquiry for all loading trucks",
  },
  favorite: {
    停车场: "Parking lot",
    导出PDF: "Export PDF",
    全部删除: "Delete all",
    询价所有装卸车: "Inquiry for all loading trucks",
  },
  forgotpwd: {
    忘记密码: "Forgot password",
    发送: "Send",
    密码发邮件:
      "If you have forgotten your password, write your login email in the fieldbelow. We will send you a link to create a new password to this email.",
  },
  login: {
    立即注册: "Register now",
    密码: "Password",
    登录: "Login",
    忘记密码: "Forgot password",
    库存超1500台叉车: "More than 1500 forklifts in stock",
    超值折扣: "Special prices",
    快速交付: "Fast delivery",
    仅限叉车经销商使用: "Access for forklift dealers only",
    电子邮箱: "Email",
    请填写您的Email: "Please fill in your Email",
    请填写您的密码: "Please fill in your password",
    请输入您的邮箱: "Please enter your Email",
    请输入密码: "Please input password",
  },
  register: {
    注册: "Register",
    登录信息: "Login information",
    联系方式: "Contact information",
    公司信息: "Company information",
    发票地址: "Invoice address",
    其他: "Others",
    你想收到时事通讯吗: "Would you like to receive the newsletter",
    发送新购买的叉车吗: "Send a newly purchased forklift",
    发送注册请求: "Send a registration request",
    请输入您的邮箱: "Please enter your Email",
    请输入密码: "Please input password",
    电子邮箱: "Email",
    密码: "Password",
    确认密码: "Confirm password",
    姓名: "Name",
    公司名称: "Company",
    联系电话: "Cellphone",
    街道和门牌号码: "Street and house number",
    城市: "City",
    邮编: "Postal code",
    请选择国家: "Please select country",
    请输入确认密码: "Please enter confirmation password",
    请输入姓名: "Please enter name",
    请填写公司名称: "Please enter company name",
    请填写手机号码: "Please enter phone number",
    请填写街道和门牌号码: "Please enter street and house number",
    请填写城市: "Please enter city",
    请输入邮政编码: "Please enter postal code",
    请选择国家: "Please select country",
    中国: "China",
    英国: "Britain",
    俄罗斯: "Russia",
    西班牙: "Spain",
    日本: "Japan",
  },
  userinfo: {
    我的账户: "My account",
    账户设置: "Account setting",
    注销: "Log off",
  },
};
